// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___s1N4s"};